import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { AuthProvider, useAuth } from '@/auth/auth-provider';
import { AppShell } from '@/components/app-shell';
import { PreferencesProvider } from '@/components/preferences-provider';
import { AcceptInvitePage } from '@/pages/accept-invite-page';
import { LoginPage } from '@/pages/login-page';
import { adminRoles } from '@/types';
import AnalyticsPage from '@/app/(dashboard)/analytics/page';
import MatchesPage from '@/app/(dashboard)/matches/page';
import NotificationsPage from '@/app/(dashboard)/notifications/page';
import OverviewPage from '@/app/(dashboard)/page';
import PlayersPage from '@/app/(dashboard)/players/page';
import SettingsPage from '@/app/(dashboard)/settings/page';
import TeamsPage from '@/app/(dashboard)/teams/page';
import TournamentsPage from '@/app/(dashboard)/tournaments/page';
import UsersPage from '@/app/(dashboard)/users/page';
import VenuesPage from '@/app/(dashboard)/venues/page';

function ProtectedLayout() {
  const { status, user } = useAuth();
  if (status === 'loading') return <main className="startup"><img src="/futsaly-mark.svg" alt="Futsaly" /><span>Loading secure workspace…</span></main>;
  if (!user || status !== 'authenticated' || !adminRoles.includes(user.role)) return <Navigate to="/login" replace />;
  return <AppShell user={user}><Outlet /></AppShell>;
}

export function App() {
  return <PreferencesProvider><AuthProvider><Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/accept-invite" element={<AcceptInvitePage />} />
    <Route element={<ProtectedLayout />}>
      <Route index element={<OverviewPage />} />
      <Route path="users" element={<UsersPage />} />
      <Route path="teams" element={<TeamsPage />} />
      <Route path="players" element={<PlayersPage />} />
      <Route path="tournaments" element={<TournamentsPage />} />
      <Route path="matches" element={<MatchesPage />} />
      <Route path="analytics" element={<AnalyticsPage />} />
      <Route path="venues" element={<VenuesPage />} />
      <Route path="notifications" element={<NotificationsPage />} />
      <Route path="settings" element={<SettingsPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></AuthProvider></PreferencesProvider>;
}
